const round = (value, decimalPlaces) => {
  if (value && decimalPlaces)
    return Number(
      Math.round(parseFloat(value + "e" + decimalPlaces)) + "e-" + decimalPlaces
    ).toFixed(decimalPlaces);
  else return undefined;
};

const CommaSeperatedNums = (num) => {
  return Number(num).toLocaleString("en", {
    minimumFractionDigits: 0,
  });
};

const isNumber = (value) => {
  return !isNaN(value) && !isNaN(parseFloat(value));
};

/**
 *
 * @param {number} num
 * @description Converts a number to a more readable format (K, M, B)
 * @example
 * scaleNumber(1500) // "1.50K"
 * scaleNumber(1500000) // "1.50M"
 * scaleNumber(1500000000) // "1.50B"
 * scaleNumber(150) // "150"
 * scaleNumber(0) // "0"
 * scaleNumber(-1500) // "-1.50K"
 * scaleNumber(-150) // "-150"
 * scaleNumber(-0) // "0"
 * scaleNumber(-0.0001) // "-0.00"
 * @returns
 */
function toFixedTrunc(x, digits = 2) {
  const factor = Math.pow(10, digits);
  return (Math.trunc(x * factor) / factor).toFixed(digits);
}
function scaleNumber(num) {
  if (num >= 1_000_000_000) {
    return toFixedTrunc(num / 1_000_000_000) + " B"; // Billions
  } else if (num >= 1_000_000) {
    return toFixedTrunc(num / 1_000_000) + " M"; // Millions
  } else if (num >= 1_000) {
    return toFixedTrunc(num / 1_000) + " K"; // Thousands
  } else {
    const valueStr = toFixedTrunc(Number(num), 2); // No conversion for smaller numbers
    console.log(
      `[INFO] No conversion happened for the Amount ${num} => ${valueStr}`
    );
    return valueStr;
  }
}

export { round, CommaSeperatedNums, scaleNumber, isNumber, toFixedTrunc };
